import wx from 'weixin-jsapi'
import request from "@/utils/request"
import shareRequest from '@/utils/shareRequest'

//刷新公众号对接基本信息
export function JsSdkUiPackage(data) {
    return shareRequest({
        url: `/WxAuthorizerInfo/GetJsSdkUiPackage`,
        method: 'post',
        data
    })
}

//获取临时的id
function tempidInfo(data) {
    return request({
        url: `/Home/GetVideoTempId`,
        method: 'post',
        data
    })
}

//添加视频点击数
function videoClick(data) {
    return request({
        url: `/Home/AddVideoClick`,
        method: 'post',
        data
    })
}

//获取临时id
function getTempId() {
    var tempId = localStorage.getItem('tempid');
    if (tempId) {
        return tempId;
    }
    tempidInfo().then((response) => {
        tempId = response.Data;
        localStorage.setItem("tempid", response.Data);
    });
    return tempId;
}


//短视频添加操作记录
export function addVideoClick(vid) {
    var tempId = getTempId();
    //请求路径
    var data = {
        VodId: vid,
        TempId: tempId,
    };
    videoClick(data).then((response) => {
        // console.log("设备数据", response.Data);
    });

}

//获取sdk配置
export function configHandle(memberId, url) {
    var data = {
        MemberId: memberId,
        Url: url
    };
    JsSdkUiPackage(data)
        .then(response => {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: response.Data.Sdk.AppId, // 必填，企业号的唯一标识，此处填写企业号corpid
                timestamp: response.Data.Sdk.Timestamp, // 必填，生成签名的时间戳
                nonceStr: response.Data.Sdk.NonceStr, // 必填，生成签名的随机串
                signature: response.Data.Sdk.Signature, // 必填，签名，见附录1
                // 必填，需要使用的JS接口列表，这个地方必须至少写一个，即便不用
                jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'],
                // 可选，需要使用的开放标签列表
                openTagList: ['wx-open-launch-weapp']
            });
        })
}

//分享朋友圈、微信好友配置
export function getShareData(url, title, desc, img) {
    // 分享到朋友圈
    wx.onMenuShareTimeline({
        title: title, // 分享标题
        link: url, // 分享链接，该链接域名必须与当前企业的可信域名一致
        imgUrl: img, // 分享图标
        success: function() {
            // 用户确认分享后执行的回调函数
        },
        cancel: function() {
            // 用户取消分享后执行的回调函数
        }
    });

    //分享给朋友
    wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: url, // 分享链接，该链接域名必须与当前企业的可信域名一致
        imgUrl: img, // 分享图标
        success: function() {
            // 用户确认分享后执行的回调函数
        },
        cancel: function() {
            // 用户取消分享后执行的回调函数
        }
    });
}